import {useEffect, useState} from 'react';
import LayoutComponent from "../components/LayoutComponent";
import TableComponent from "../components/TableComponent";
import {useApi} from "../provider/ApiProvider";
import CompanyDialog from "../dialogs/CompanyDialog";
import {Button, Popconfirm} from "antd";
import {DeleteOutlined, RightOutlined, EditFilled, PlusOutlined} from "@ant-design/icons";
import PlatformDialog from "../dialogs/PlatformDialog";
import CustomerDialog from "../dialogs/CustomerDialog";

export default function CustomersPage(){

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            render: text => <a>{text}</a>,
        },
        {
            title: 'Adı',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Platform',
            render: (record) => record.Platform.name
        },


        {
            title: 'İşlemler',
            render: (record) => (
                <div>
                    <Popconfirm
                        title="Silmek istediğinize emin misiniz?"
                        onConfirm={() => {deleteRow(record.id, record)}}
                        onCancel={() => {
                            return;
                        }}
                        okText="Evet"
                        cancelText="Hayır"
                    >
                        <Button danger><DeleteOutlined/></Button>
                    </Popconfirm>
                    <Button  style={{marginLeft: '4%'}} onClick={() => editDialog(record)}>
                        <EditFilled />
                    </Button>

                </div>
            )
        }

    ];

    const {api} = useApi();
    const [platforms, setPlatforms] = useState({totalCount: 0, items:[]});
    const [dialog, setDialog] = useState({open: false, data: null});

    useEffect(() => {
        load({skip: 0, max: 10});

    }, [])

    async function load(params){
        api.get('/customerRouter/customer/all', params).then(resp => {
            setPlatforms({totalCount: resp.totalCount, items: resp.data})
        })
    }

    function addDialog(){
        setDialog({open: true, data: null});
    }

    function editDialog(data){
        setDialog({open: true, data: data});
    }

    function deleteRow(id, record){
        api.delete("/customerRouter/customer/delete/" + id).then(resp => {
            load();
        }).finally(() => {

        })
    }

    return (
        <LayoutComponent title={"Müşteriler"} links={
            [
                {
                    title: 'Müşteri Listesi',
                    url: '/'
                },

            ]}
                         newButton={<>
                             <Button icon={<PlusOutlined />} onClick={() => addDialog()} type="primary">Ekle</Button>
                         </>}
        >
            <TableComponent
                columns={columns}
                data={platforms}
                clickRow={(data) => editDialog(data)}
            />
            <CustomerDialog
                open={dialog.open}
                data={dialog.data}
                onChange={() => load()}
                onClose={() => setDialog({open: false, data: null})}
            />

        </LayoutComponent>
    )
}
